import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "@redux/actions";
import {
  ADMIN_ROLE,
  DEFAULT_AVATAR,
  GUEST_ROLE,
  STUDENT_ROLE,
} from "@constants";
import { useNavigate } from "react-router-dom";
import styles from "./styles/AvatarPopup.module.css";
import clsx from "clsx";
import { Button, Stack } from "react-bootstrap";
import { AccessControl } from "@components/AccessControl";
import { replaceErrorAvatar } from "@helpers";

const AvatarPopup = () => {
  // state
  const [popupVisible, setPopupVisible] = useState(false);

  // variables

  // logics before hooks

  // hooks
  const popupRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user);
  const { login } = useSelector((state) => state.auth);
  const user = profile.data ?? {
    fullName: "",
    email: "",
    avatarUrl: DEFAULT_AVATAR,
  };
  const userRole = login.role || GUEST_ROLE;

  // logics
  const togglePopup = () => {
    setPopupVisible(!popupVisible);
  };

  const hidePopup = (e) => {
    if (
      popupRef.current &&
      popupVisible &&
      !popupRef.current.contains(e.target)
    ) {
      setPopupVisible(false);
    }
  };

  const handleViewProfile = () => {
    navigate("/my-profile-view");
    togglePopup();
  };

  const handleViewDashboard = () => {
    navigate(
      userRole === STUDENT_ROLE ? "/student-dashboard" : "/instructor-dashboard"
    );
    togglePopup();
  };

  const handleNavigate = (target) => {
    navigate(target);
    togglePopup();
  };

  const handleSignOut = () => {
    dispatch(logoutAction());
  };

  // UI partials
  const avatar = (
    <Button
      variant="light"
      className={clsx(styles.avatar, "border-0")}
      onClick={togglePopup}
    >
      <img src={user.avatarUrl} alt="avatar" onError={replaceErrorAvatar} />
    </Button>
  );

  const popup = (
    <Stack className={clsx(styles.popup, popupVisible ? styles.visible : "")}>
      <Stack className={clsx("p-3", "border-bottom")} gap={2}>
        <Stack direction="horizontal" gap={3}>
          <div className={styles.popupAvatar}>
            <img
              src={user.avatarUrl}
              alt="avatar"
              onError={replaceErrorAvatar}
            />
          </div>
          <Stack>
            <strong>{user.fullName}</strong>
            <span className="text-muted">{user.email}</span>
          </Stack>
        </Stack>
        <AccessControl exceptRoles={[ADMIN_ROLE]}>
          <button className={styles.linkButton} onClick={handleViewProfile}>
            View {userRole} Profile
          </button>
        </AccessControl>
      </Stack>
      <AccessControl exceptRoles={[ADMIN_ROLE]}>
        <button onClick={handleViewDashboard}>Cursus Dashboard</button>
      </AccessControl>
      <button
        onClick={() =>
          handleNavigate(
            userRole === ADMIN_ROLE ? "/admin-setting" : "/setting"
          )
        }
      >
        Setting
      </button>
      {/* <AccessControl exceptRoles={[ADMIN_ROLE]}>
        <Fragment>
          <button onClick={() => handleNavigate("/help")}>Help</button>
          <button onClick={() => handleNavigate("/send-feedback")}>
            Send Feedback
          </button>
        </Fragment>
      </AccessControl> */}
      <button onClick={handleSignOut}>Sign Out</button>
    </Stack>
  );

  // effects
  useEffect(() => {
    if (popupVisible) {
      document.addEventListener("mousedown", hidePopup, { once: true });
    }
    return () => document.removeEventListener("mousedown", hidePopup);
  }, [popupVisible]);

  // render
  return (
    <div ref={popupRef} className={styles.avatarPopup}>
      {avatar}
      {popup}
    </div>
  );
};

/* required: display name */
AvatarPopup.displayName = "AvatarPopup";

/* required: props types */
AvatarPopup.propTypes = {};

/* required: default props */
AvatarPopup.defaultProps = {};

export { AvatarPopup };
